import React, { useEffect, useMemo } from 'react';
import { toast } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import moment from 'moment';
import { fetchInbox, fetchPengajuans } from '../../services/pengajuanService'; 
import { getUserLevel } from '../../helpers/auth'; 

const ApprovalPopup = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const authInfo = getUserLevel();
    const userLevel = authInfo?.level?.toUpperCase();
    const userDivisi = authInfo?.divisi?.toUpperCase();

    const canAccessNotification = useMemo(() => {
        return (userDivisi === 'KEUANGAN') || 
               (['DIRUT', 'DIREKTUR', 'DIREKSI'].includes(userLevel)) || 
               (userDivisi === 'DIREKSI');
    }, [userLevel, userDivisi]);

    useEffect(() => {
        if (!canAccessNotification) {
        toast.dismiss(); // Hapus semua toast yang menggantung
        return;
    }

        const checkSystemNotifications = async () => {
            try {
                // 1. CEK ANTREAN PERSETUJUAN (Kuning)
                const resInbox = await fetchInbox({ per_page: 50 });
                const dataInbox = resInbox.data || [];
                const antreanSetuju = dataInbox.filter(item => 
                    ['DIAJUKAN', 'APPROVED'].includes(item.status_pengajuan)
                );

                if (antreanSetuju.length > 0) {
                    toast.warning(
                        <div onClick={() => navigate('/pengajuan-transaksi')} style={{ cursor: 'pointer' }}>
                            <strong className="d-block">🔔 Antrean Persetujuan</strong>
                            <small>Ada {antreanSetuju.length} pengajuan menunggu persetujuan Anda.</small>
                        </div>,
                        { toastId: "approval-notif", position: "top-right", autoClose: 5000 }
                    );
                }

                // 2. CEK SIAP DICAIRKAN (Biru - Khusus Keuangan)
                if (userDivisi === 'KEUANGAN') {
                    // Kita ambil data pengajuan umum
                    const resAll = await fetchPengajuans({ 
                        page: 1, 
                        per_page: 20 // Karena di Backend sudah kita buat ORDER APPROVED di atas, 20 data sudah cukup
                    });
                    
                    const allData = resAll.data || [];
                    const siapCair = allData.filter(item => 
                        item.status_pengajuan === 'APPROVED'
                    );

                    if (siapCair.length > 0) {
                        toast.info(
                            <div onClick={() => navigate('/pengajuan-transaksi')} style={{ cursor: 'pointer' }}>
                                <strong className="d-block">💸 Siap Dicairkan</strong>
                                <small>Ada {siapCair.length} pengajuan yang siap dicairkan (Status: Approved).</small>
                            </div>,
                            { 
                                toastId: "disburse-notif", 
                                position: "top-right", 
                                autoClose: 8000, 
                                theme: "colored" 
                            }
                        );
                    }
                }
            } catch (error) {
                console.error("Popup check error:", error);
            }
        };

        // Jalankan pengecekan setiap kali pindah halaman
        checkSystemNotifications();

    }, [location.pathname, canAccessNotification, userDivisi, navigate]);

    return null;
};

export default ApprovalPopup;